import styled from 'styled-components';

const FormTextWrap = styled.div`
    font-size: 1rem;
    height: auto;
    margin-bottom:1rem;
`;

export default FormTextWrap;